// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/pages/eventspage.less
// module id = 422
// module chunks = 0